import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

const API_LIST = '/catalog-categories';
const API_DETAIL = (id: number) => `/catalog-categories/${id}`;

export interface CatalogCategory {
  id: number;
  name?: string;
}

export const useCatalogCategories = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<CatalogCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    catalogCategories: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCatalogCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CatalogCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    catalogCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};
